import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var StarsBackground = /*#__PURE__*/function () {
  function StarsBackground(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, StarsBackground);
    // TODO: allow colour to be string value to avoid calculating colour when single item in array
    this.STAR_COLOR = options.star_color || ["#205375"];
    this.STAR_SIZE = options.star_size || 5;
    this.STAR_MIN_SCALE = options.star_min_scale || 0.2;
    this.OVERFLOW_THRESHOLD = options.overflow_threshold || 50;
    this.STAR_DENSITY = options.star_density || 0.01; // number between 0 and 1, closer to 0 recommended!
    this.SPEED = options.speed || 0.1; // number between 0 and 1

    this.canvas = document.querySelector(selector || 'canvas');
    this.context = this.canvas.getContext('2d');
    this.scale = window.devicePixelRatio || 1; // device pixel ratio
    this.width = this.canvas.offsetWidth * this.scale;
    this.height = this.canvas.offsetHeight * this.scale;
    this.velocity = {
      x: 0,
      y: 0,
      tx: 0,
      ty: 0,
      z: 0.01 * this.SPEED
    };
    this.stars = [];
    if (!this.canvas) return;
    this.generate();
    this.resize();
    this.step();

    // TODO: debounce resize!
    // window.onresize = this.resize.bind(this);
    window.addEventListener('resize', this.resize.bind(this));
  }
  _createClass(StarsBackground, [{
    key: "star_count",
    get: function get() {
      return this.width * this.height * 0.01 * this.STAR_DENSITY;
    }
  }, {
    key: "generate",
    value: function generate() {
      for (var i = 0; i < this.star_count; i++) {
        this.stars.push({
          x: 0,
          y: 0,
          z: this.STAR_MIN_SCALE + Math.random() * (1 - this.STAR_MIN_SCALE),
          color: this.STAR_COLOR[Math.floor(Math.random() * 2)]
        });
      }
    }
  }, {
    key: "placeStar",
    value: function placeStar(star) {
      star.x = Math.random() * this.width;
      star.y = Math.random() * this.height;
    }
  }, {
    key: "recycleStar",
    value: function recycleStar(star) {
      var direction = 'z';
      var vx = Math.abs(this.velocity.x);
      var vy = Math.abs(this.velocity.y);
      if (vx > 1 || vy > 1) {
        var axis;
        if (vx > vy) {
          axis = Math.random() < vx / (vx + vy) ? 'h' : 'v';
        } else {
          axis = Math.random() < vy / (vx + vy) ? 'v' : 'h';
        }
        if (axis === 'h') {
          direction = this.velocity.x > 0 ? 'l' : 'r';
        } else {
          direction = this.velocity.y > 0 ? 't' : 'b';
        }
      }
      star.z = this.STAR_MIN_SCALE + Math.random() * (1 - this.STAR_MIN_SCALE);
      if (direction === 'z') {
        star.z = 0.1;
        star.x = Math.random() * this.width;
        star.y = Math.random() * this.height;
      } else if (direction === 'l') {
        star.x = -this.OVERFLOW_THRESHOLD;
        star.y = this.height * Math.random();
      } else if (direction === 'r') {
        star.x = this.width + this.OVERFLOW_THRESHOLD;
        star.y = this.height * Math.random();
      } else if (direction === 't') {
        star.x = this.width * Math.random();
        star.y = -this.OVERFLOW_THRESHOLD;
      } else if (direction === 'b') {
        star.x = this.width * Math.random();
        star.y = this.height + this.OVERFLOW_THRESHOLD;
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      // reset variables
      this.stars = [];
      this.scale = window.devicePixelRatio || 1;
      this.width = this.canvas.offsetWidth * this.scale;
      this.height = this.canvas.offsetHeight * this.scale;

      // TODO: only set these explicit height/width values onload
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      this.generate();
      this.stars.forEach(this.placeStar.bind(this));
    }
  }, {
    key: "step",
    value: function step() {
      this.context.clearRect(0, 0, this.width, this.height);
      this.update();
      this.render();
      requestAnimationFrame(this.step.bind(this));
    }
  }, {
    key: "update",
    value: function update() {
      var _this = this;
      this.stars.forEach(function (star) {
        star.x += _this.velocity.x * star.z;
        star.y += _this.velocity.y * star.z;
        star.x += (star.x - _this.width / 2) * _this.velocity.z * star.z;
        star.y += (star.y - _this.height / 2) * _this.velocity.z * star.z;
        star.z += _this.velocity.z;

        // recycle when out of bounds
        if (star.x < -_this.OVERFLOW_THRESHOLD || star.x > _this.width + _this.OVERFLOW_THRESHOLD || star.y < -_this.OVERFLOW_THRESHOLD || star.y > _this.height + _this.OVERFLOW_THRESHOLD) {
          _this.recycleStar(star);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      this.stars.forEach(function (star) {
        _this2.context.beginPath();
        _this2.context.lineCap = 'round';
        _this2.context.lineWidth = _this2.STAR_SIZE * star.z * _this2.scale;
        _this2.context.strokeStyle = star.color;
        _this2.context.beginPath();
        _this2.context.moveTo(star.x, star.y);
        _this2.context.lineTo(star.x, star.y);
        _this2.context.stroke();
      });
    }
  }]);
  return StarsBackground;
}();
export { StarsBackground as default };